import DOMPurify from 'dompurify';

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;

const RICH_TEXT_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  's',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'a',
  'blockquote',
];

const RICH_TEXT_ALLOWED_ATTR = ['href', 'target', 'rel'];

export const hasRichHtmlTags = (value: string): boolean => HTML_TAG_PATTERN.test(value);

export const sanitizeRichText = (value: string): string =>
  DOMPurify.sanitize(value, {
    ALLOWED_TAGS: RICH_TEXT_ALLOWED_TAGS,
    ALLOWED_ATTR: RICH_TEXT_ALLOWED_ATTR,
    FORBID_ATTR: ['style', 'onerror', 'onclick', 'onload'],
  });

export const richTextToPlainText = (value: string): string => {
  const stripped = DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  return stripped.replace(/\s+/g, ' ').trim();
};
